'use strict';

export class ShareList {
    constructor(params) {
        this.params = params;
        this.pagenation = null;
        this.sending = false;
    }

    set params(params) {
        this._params = params;
    }

    get params() {
        return this._params;
    }

    set pagen(object) {
        this.pagenation = object;
    }

    get pagen() {
        return this.pagenation;
    }

    loadNextPage() {
        let self = this;
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let xhr = new XMLHttpRequest();

            formData.append('template', self.params.templateName);
            formData.append('parameters', self.params.arParams);
            formData.append('sessid', self.params.sessid);
            formData.append('siteId', self.params.siteId);
            formData.append('page', self.pagen.getNavNextPageNumber());
            formData.append('ajax_filter', self.params.ajax_filter);

            xhr.open('POST', self.params.ajaxPath, true);

            xhr.onload = function () {
                if (xhr.status != 200)
                    reject(new Error("Network Error"));
                else {
                    resolve(this.responseText);
                }
            };
            xhr.onerror = function() {
                reject(new Error("Network Error"));
            };
            self.sending = true;
            xhr.send(formData);
        });
    }
}